import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { setCsrfToken } from "@/lib/queryClient";

export function useCsrfToken(): void {
  const { data } = useQuery<{ csrfToken: string }>({
    queryKey: ["/api/csrf-token"],
    staleTime: Infinity,
    retry: false,
  });

  useEffect(() => {
    if (data?.csrfToken) {
      setCsrfToken(data.csrfToken);
    }
  }, [data]);
}
